import Service from "../../Service";

const resource = "HmnMassiveRecruitment/";

export default {
  pagination(dtr, requestID) {
    return Service.post(resource + "pagination", dtr, {
      params: { requestID: requestID },
    });
  },
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  byUUID(MrcUUID) {
    return Service.post(resource + "byUUID", null, {
      params: { MrcUUID: MrcUUID },
    });
  },
  GetAvailablePositions(CmpID) {
    return Service.post(resource + "GetAvailablePositions", null, {
      params: { CmpID: CmpID },
    });
  },
};
